export enum ConsumerRouteSearchParam {
  Reset = 'reset'
}
